import { render } from "./FontPreviewer.vue?vue&type=template&id=61bdb51e"
import script from "./index?vue&type=script&lang=js&external"
export * from "./index?vue&type=script&lang=js&external"

import "./FontPreviewer.vue?vue&type=style&index=0&id=61bdb51e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__